import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row fit no-wrap items-top" }
const _hoisted_2 = { class: "q-pl-xl q-ml-md" }

import PageCaption from '@/components/PageCaption.vue';
import InstitutionalIdentificationSectionView from '@/components/telasInstitucionais/institutionalFormats/InstitutionalIdentificationSectionView.vue';
import InstitutionalImagesSection from '@/components/telasInstitucionais/InstitutionalImagesSection.vue';
import InstitutionalDevicesSection from '@/components/telasInstitucionais/InstitutionalDevicesSection.vue';
//import InstitutionalDevicesDistributionSection from '@/components/telasInstitucionais/InstitutionalDevicesDistributionSection.vue';
import InstitutionalRequestedAdjustmentsSection from '@/components/telasInstitucionais/InstitutionalRequestedAdjustmentsSection.vue';
import InstitutionalActionButtonsSection from '@/components/telasInstitucionais/institutionalFormats/InstitutionalActionButtonsSection.vue';
import { onMounted, computed } from 'vue'
import { useRouter } from 'vue-router';
import { useInstitutionalStore } from '@/stores/institutionalStore';
import ModalRequestAdjustmentsInstitucional from '@/views/modals/ModalRequestAdjustmentsInstitucional.vue';
import { EnumRouteNames } from '@/enums/enums';
import InstitutionalAccordion from '@/components/telasInstitucionais/institutionalFormats/InstitutionalAccordion.vue';

// const institutionalData = computed(() => {
//   return institutionalStore.reviewData || institutionalStore.institutionalDetail || institutionalStore.institutionalDraft
// })

export default /*@__PURE__*/_defineComponent({
  __name: 'PageInstitutionalReview',
  setup(__props) {

const institutionalData = computed(() => {
  return institutionalStore.reviewData || institutionalStore.institutionalDetail || institutionalStore.institutionalDraft
})


const institutionalStore = useInstitutionalStore();
const router = useRouter();

onMounted(async () => {
  const id = router.currentRoute.value.params.id

  if (!id && !institutionalStore.reviewData) {
    router.push({ name: EnumRouteNames.INSTITUTIONAL_SEARCH })
    return
  }

  if (id && !institutionalStore.reviewData && !institutionalStore.institutionalDetail) {
    await institutionalStore.fetchInstitutionalById(Number(id))

    const imagens = institutionalStore.institutionalDetail?.imagens
    if (imagens?.length) {
      institutionalStore.setImagensDraft(imagens)
    }
  }

  // ✅ PRESERVAR DADOS AO VOLTAR
  sessionStorage.setItem('from', 'review')
})

const showSectionViewAskAdjustment = computed(() => {
  return institutionalStore.institutionalDetail?.comentarioAjuste
})




/*onMounted(async () => {
  const id = router.currentRoute.value.params.id

  if (!id && !institutionalStore.reviewData) {
    router.push({ name: EnumRouteNames.INSTITUTIONAL_SEARCH })
    return
  }

  if (id && !institutionalStore.reviewData && !institutionalStore.institutionalDetail) {
    await institutionalStore.fetchInstitutionalById(Number(id))

    const imagens = institutionalStore.institutionalDetail?.imagens
    if (imagens?.length) {
      institutionalStore.setImagensDraft(imagens)
    }
  }
})*/


// const institutionalReviewData = computed(() => {
//   const detail = institutionalData.value
//   if (!detail) return null

//   const imagens = detail.imagens || []

//   const mapTempo = (posicao: number) => {
//     const img = imagens.find((i: any) => i.posicaoImagem === posicao)
//     return img?.duracaoImagem || 10
//   }

//   return {
//     id: detail.id,
//     accordions: {
//       telasIniciais: [
//         { id: 1, tela: 'Tela 1', posicao: 1, ordem: 1, tempo: mapTempo(1) },
//         { id: 2, tela: 'Tela 2', posicao: 2, ordem: 2, tempo: mapTempo(2) },
//         { id: 3, tela: 'Tela 3', posicao: 3, ordem: 3, tempo: mapTempo(3) },
//         { id: 4, tela: 'Tela 4', posicao: 4, ordem: 4, tempo: mapTempo(4) }
//       ],

//       telasAtm: [
//         { id: 8, botao: 'Sacar sem cartão', posicao: 8 },
//         { id: 9, botao: 'Recarga celular', posicao: 9 },
//         { id: 10, botao: 'Mais serviços', posicao: 10 },
//         { id: 11, botao: 'Depositar dinheiro', posicao: 11 }
//       ],

//       telasAguardeGeral: [
//         { id: 6, tela: 'Tela Geral', posicao: 6 }
//       ],

//       telasAguardeChip: [
//         { id: 7, tela: 'Tela Chip', posicao: 7 }
//       ],

//       telasAbertura: [
//         { id: 5, tela: 'Tela Abertura', posicao: 5 }
//       ],

//       imagens,
//       corTexto: detail.corTexto ?? null,
//       exibeTelaAbertura: detail.exibeTelaAbertura ?? false,
//       alterarTelaAbertura: (detail as any).alterarTelaAbertura ?? 'nao'
//     }
//   }
// })

const institutionalReviewData = computed(() => {
  const detail = institutionalData.value
  if (!detail) return null

  const imagens = detail.imagens || []

  // const telasCadastradas = Array.isArray(detail.telasCadastradas)
  //   ? detail.telasCadastradas.map((t: any) => t.tipoTela ?? t)
  //   : String(detail.telasCadastradas || '')
  //       .split(',')
  //       .map((t: string) => t.trim())
  //       .filter(Boolean)

  // const hasTela = (tipo: string) => telasCadastradas.includes(tipo)

  const mapTempo = (posicao: number) => {
    const img = imagens.find((i: any) => i.posicaoImagem === posicao)
    return img?.duracaoImagem || 10
  }
  const telasCadastradas = Array.isArray(detail.telasCadastradas)
  ? detail.telasCadastradas.map((t: any) => t.tipoTela ?? t)
  : String(detail.telasCadastradas || '')
      .split(',')
      .map((t: string) => t.trim())
      .filter(Boolean)

  const hasTela = (tipo: string) => telasCadastradas.includes(tipo)

  return {
    id: detail.id,
    accordions: {
      telasIniciais: [
        { id: 1, tela: 'Tela 1', posicao: 1, ordem: 1, tempo: mapTempo(1) },
        { id: 2, tela: 'Tela 2', posicao: 2, ordem: 2, tempo: mapTempo(2) },
        { id: 3, tela: 'Tela 3', posicao: 3, ordem: 3, tempo: mapTempo(3) },
        { id: 4, tela: 'Tela 4', posicao: 4, ordem: 4, tempo: mapTempo(4) }
      ],
      telasAtm: [
        { id: 8, botao: 'Sacar sem cartão', posicao: 8 },
        { id: 9, botao: 'Recarga celular', posicao: 9 },
        { id: 10, botao: 'Mais serviços', posicao: 10 },
        { id: 11, botao: 'Depositar dinheiro', posicao: 11 }
      ],
      telasAguardeGeral: [
        { id: 6, tela: 'Tela Geral', posicao: 6 }
      ],
      telasAguardeChip: [
        { id: 7, tela: 'Tela Chip', posicao: 7 }
      ],
      telasAbertura: [
        { id: 5, tela: 'Tela Abertura', posicao: 5 }
      ],
      imagens,
      corTexto: detail.corTexto ?? null,
      exibeTelaAbertura: detail.exibeTelaAbertura ?? false,
      alterarTelaInicial: hasTela('INICIAL') ? 'sim' : 'nao',
      alterarTelaAguarde: hasTela('AGUARDE') ? 'sim' : 'nao',
      alterarTelaAbertura: hasTela('ABERTURA') ? 'sim' : 'nao'
    }
  }
})


return (_ctx: any,_cache: any) => {
  const _component_c_q_separator = _resolveComponent("c-q-separator")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_c_q_separator, {
      class: "q-pb-lg",
      withBackButton: true
    }),
    _createVNode(PageCaption, {
      pageCaptionTitle: "Revisão",
      pageCaptionDescription: "Revise o Cadastro e Envie para Aprovação"
    }),
    _createVNode(InstitutionalIdentificationSectionView, {
      institutionalData: institutionalData.value,
      showDownloadButtons: false
    }, null, 8, ["institutionalData"]),
    _createVNode(_component_c_q_separator, { class: "q-pb-md" }),
    _createVNode(InstitutionalImagesSection),
    (institutionalReviewData.value)
      ? (_openBlock(), _createBlock(InstitutionalAccordion, {
          key: 0,
          accordionsData: institutionalReviewData.value.accordions,
          mode: "view"
        }, null, 8, ["accordionsData"]))
      : _createCommentVNode("", true),
    _createVNode(_component_c_q_separator, { class: "q-pb-md" }),
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "q-pr-xl q-mr-xl" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        (showSectionViewAskAdjustment.value)
          ? (_openBlock(), _createBlock(InstitutionalRequestedAdjustmentsSection, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_c_q_separator, { class: "q-pt-xl q-pb-md" }),
    _createVNode(InstitutionalActionButtonsSection, {
      propShowBtnBackEdit: true,
      propShowBtnCancelCreateNewCampaign: true,
      propShowBtnSaveFocusedInstitutional: true,
      propShowBtnApproveFocusedCampaign: true,
      propShowBtnResendFocusedInstitutionalToApprove: true,
      propShowBtnSendFocusedInstitutionalToApprove: true
    }),
    _createVNode(ModalRequestAdjustmentsInstitucional)
  ]))
}
}

})